import {
  Form,
  InputNumber,
  Popconfirm,
  Table,
  Typography,
  Input,
  Space,
  Button,
  notification,
  Select,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import NetworkService from "../services/NetworkService";
import { useState, useRef, useEffect } from "react";
import Highlighter from "react-highlight-words";
import { useAtom } from "jotai";
import { selectedRecord, accessTokenAtom } from "../atoms";
import moment from "moment";

let tablelabel;

const EditableCell = ({ children, ...restProps }) => {
  return <td {...restProps}>{children}</td>;
};

const RerunTable = ({ defaultColumns, dummyData, label, token }) => {
  const [accessAtom, setAPIAtom] = useAtom(accessTokenAtom);
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([...dummyData]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) => record.serialNumber === editingKey;
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const [currentRecord, setCurrentRecord] = useAtom(selectedRecord);
  const [tableSummaryData, setSummaryData] = useState([]);
  const [currentRows, setCurrentRows] = useState(5);

  useEffect(() => {
    setDataSource([...dummyData]);
  }, [dummyData]);

  tablelabel = label;

  const openNotification = () => {
    api.error({
      message: `Failed`,
      description: "Certificate was not successfully Regenerated",
      placement: "top",
    });
  };

  const successNotification = () => {
    api.success({
      message: `Success`,
      description: "Certificate Regenerated Successfully",
      placement: "top",
    });
  };

  const handleRerun = (record) => {
    const networkServiceObj = new NetworkService();
    let input = { id: record.id };
    networkServiceObj.regenerateFailedCertService(input, token).then((res) => {
      if (res.messageCode == 200) {
        const newItems = dataSource.filter((item) => item.id != record.id);

        setDataSource(newItems);
        successNotification();
      } else {
        openNotification();
      }
    });

    // use the href attribute for the certificate field because it
    // is an href object
  };

  const handleCancel = () => {
    setEditingKey("");
  };

  const onSelectChange = (newSelectedRowKeys, record) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setCurrentRecord(record[0]);
  };
  const rowSelection = {
    selectedRowKeys,
    type: "radio",
    onSelect: () => console.log("test"),
    onChange: onSelectChange,
  };

  const handleSave = async (record) => {
    try {
      const row = await form.validateFields();

      // If the edited cell in the row is a link, then transform
      // the data to be saved
      // CHANGE THIS LINK TO BACK TO CERTIFICATE FOR RESIDENTIAL
      // if (row['projectLink']) {
      //     row['projectLink'] =  <a href={row['projectLink']} target="_blank" rel="noreferrer">Link</a>
      // }
      const newData = [...dataSource];
      const index = newData.findIndex((item) => record.serialNumber === item.serialNumber);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setDataSource(newData);
        fetch(`${process.env.REACT_APP_API_URL}ActiveProject/UpdateActiveProject`, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(newData[index]),
        });
        setEditingKey("");
      } else {
        newData.push(row);
        setDataSource(newData);
        setEditingKey("");
      }
    } catch (errInfo) {}
  };

  const handleDelete = (record) => {
    const newData = dataSource.filter((item) => item.id !== record.id);
    fetch(`${process.env.REACT_APP_API_URL}ActiveProject/DeleteProject?projectId=${record.id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    setDataSource(newData);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText((selectedKeys.length === 0 && "") || selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm, dataIndex) => {
    clearFilters();
    handleSearch([], confirm, dataIndex);
  };

  function isIsoDate(str) {
    // if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{2}$/.test(str)) return false;
    // const d = new Date(str);
    // return d instanceof Date && !isNaN(d) && d.toISOString()===str; // valid date
    return (
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{0,3}$/.test(str) ||
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(str)
    );
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters, confirm, dataIndex)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : null,
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text, record) => {
      let dateDisplay;
      if (isIsoDate(text)) {
        const date = new Date(text);
        // Get the day, month, and year from the date object
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // month is 0-indexed
        const year = date.getFullYear().toString();
        // Combine the day, month, and year into a single string with the desired format
        dateDisplay = `${day}-${month}-${year}`;
      }

      return searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={isIsoDate(text) ? dateDisplay : text ? text.toString() : ""}
        />
      ) : isIsoDate(text) ? (
        dateDisplay
      ) : (
        text
      );
    },
  });

  const columns = defaultColumns.map((col) => {
    // Column certificate doesnt need to have search filter
    // CHANGE THIS LINK TO BACK TO CERTIFICATE FOR RESIDENTIAL
    if (col.dataIndex === "projectLink") {
      return col;
    }

    // Add a search filter functionality
    const newCol = {
      ...col,
      ...getColumnSearchProps(col.dataIndex),
    };

    if (col.dataIndex !== "operation") {
      return newCol;
    }

    // Add edit and delete functionality under the column "operation"
    return {
      ...col,
      render: (_, record) => {
        const editable = isEditing(record);
        return (
          <span>
            <Typography.Link
              disabled={editingKey !== ""}
              onClick={() => handleRerun(record)}
              style={{ marginRight: "8px" }}
            >
              Rerun
            </Typography.Link>
            {/* <Popconfirm title="Do you want to remove this record?" onConfirm={() => handleDelete(record)} disabled={record.availableQuantity==record.totalQuantity?false:true}>
                            <Typography.Link>
                                Delete
                            </Typography.Link>
                        </Popconfirm> */}
            {/* {record.availableQuantity==record.totalQuantity?<Popconfirm title="Do you want to remove this record?" onConfirm={() => handleDelete(record)} disabled={record.availableQuantity==record.totalQuantity?false:true}>
                            <Typography.Link>
                                Delete
                            </Typography.Link>
                        </Popconfirm>: <Typography.Link onClick={()=>openNotification()}>
                                Delete
                            </Typography.Link>} */}
          </span>
        );
      },
    };
  });

  // Make the cell of each row editable
  const mergedColumns = columns.map((col) => {
    return col;
  });

  const components = {
    body: {
      cell: EditableCell,
    },
  };

  return (
    <div style={{}}>
      {contextHolder}
      <Form form={form} component={false}>
        <Table
          summary={(data) => {
            // parse the certificate object
            // get only the href string
            const x = data.map((d) => ({
              ...d,
              ...("certificate" in d && { certificate: d.certificate?.props?.href }),
            }));

            // Summary needs to return a React.ReactNode
            // We need this so that we can get a reference
            // to the current data of the table when we
            // export to excel or pdf
            return (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell className="test-data d-none">
                    {JSON.stringify(x)}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
          components={components}
          bordered
          dataSource={[...dataSource]}
          columns={mergedColumns}
          rowKey={"id"}
          rowClassName="editable-row"
          pagination={{
            pageSize: currentRows,
            onChange: (page, pageSize) => setCurrentRows(pageSize),
            showSizeChanger: true,
          }}
        />
      </Form>
    </div>
  );
};

export default RerunTable;
